module.exports = __webpack_public_path__ + "media/public/fonts/PragmaticaSlabLight/PragmaticaSlabLight-5d9d2d539723f4cbc4dbe7cbe790578d.svg";